import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import styles from './ElementData.styles';

interface ElementDataRowValueProps {
    children: ReactNode;
}
export default function ElementDataRowValue(props: ElementDataRowValueProps) {
    const { children } = props;

    return (
        <Box sx={styles.value} className={'element-data-row-value'}>
            {children}
        </Box>
    );
}
